import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useCallback } from "react";
import { usePostPage_UpdateCommentMutation } from "sprout-graphql";
export default function useUpdateComment() {
    const [updateCommentMutation] = usePostPage_UpdateCommentMutation();
    const showSnackbar = useSnackbar();
    return useCallback(({ id , nodeId , text  })=>{
        updateCommentMutation({
            variables: {
                commentId: id,
                text
            },
            optimisticResponse: {
                updateCommentById: {
                    comment: {
                        id,
                        nodeId,
                        text,
                        updatedAt: new Date().toISOString(),
                        editedAt: new Date().toISOString(),
                        __typename: "Comment"
                    },
                    __typename: "UpdateCommentPayload"
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        showSnackbar,
        updateCommentMutation
    ]);
};
